import React from 'react';
import $ from 'jquery';
import { CONF_RTB } from '../../../../constants/Labels';
import { parseToFloat } from '../../../../helpers/tools';
class RTBSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'rtb';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
    this.vpmtList = {
      '': ' Disable passing the parameter in the ad call',
      1: '1 - Autoplay (sound on)',
      2: '2 - Autoplay (sound off)',
      3: '3 - Click to play',
      4: '4 - Play on mouse-over',
    };
  }

  componentDidMount() {
    this.toggleBlurListeners(true);
  }

  componentWillUnmount() {
    this.toggleBlurListeners(false);
  }
  /** Used for import settings, to display on active tab errors */
  componentDidUpdate() {
    this.toggleBlurListeners(false);
    this.toggleBlurListeners(true);
  }

  toggleBlurListeners = addListeners => {
    if (addListeners) {
      $('#' + this.section)
        .find('input[name="vdmin"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="vdmax"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="vbrmin"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="vbrmax"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="vpmt"]')
        .on(
          'blur',
          (event => {
            event.target.value = parseToFloat(event.target.value);
            this.props.validate(event, 'number', false, this);
          }).bind(this)
        );
      $('#' + this.section)
        .find('input[name="pgDomain"]')
        .on(
          'blur',
          (event => {
            this.props.validate(event, 'string', false, this);
          }).bind(this)
        );
    } else {
      $('#' + this.section)
        .find('input[name="vdmin"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="vdmax"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="vbrmin"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="vbrmax"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="vpmt"]')
        .off('blur');
      $('#' + this.section)
        .find('input[name="pgDomain"]')
        .off('blur');
    }
  };

  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div
          className="placementDescription"
          onClick={e => this.props.toggleElement(e, '.settingsInputs')}
        >
          <div className="pluginSectionsTitle rtbTitle">RTB Settings</div>
        </div>
        <div className="settingsInputs">
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: CONF_RTB }}
          ></div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>vdmin</label>
              </div>
              <div className="smallInput">
                <label>vdmax</label>
              </div>
            </div>
            <div className="smallInput">
              <input
                type="text"
                name="vdmin"
                key={this.props.rtb.vdmin}
                className="textFiled"
                defaultValue={this.props.rtb.vdmin}
                min="1"
              />
              <div className="validationError"></div>
            </div>
            <div className="smallInput">
              <input
                type="text"
                name="vdmax"
                key={this.props.rtb.vdmax}
                className="textFiled"
                defaultValue={this.props.rtb.vdmax}
                min="1"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>vbrmin</label>
              </div>
              <div className="smallInput">
                <label>vbrmax</label>
              </div>
            </div>
            <div className="smallInput">
              <input
                type="text"
                name="vbrmin"
                key={this.props.rtb.vbrmin}
                className="textFiled"
                defaultValue={this.props.rtb.vbrmin}
                min="1"
              />
              <div className="validationError"></div>
            </div>
            <div className="smallInput">
              <input
                type="text"
                name="vbrmax"
                key={this.props.rtb.vbrmax}
                className="textFiled"
                defaultValue={this.props.rtb.vbrmax}
                min="1"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>vpmt</label>
              <br />
              <select
                key={this.props.rtb.vpmt}
                name="vpmt"
                defaultValue={this.props.rtb.vpmt}
                onChange={e => this.props.handleOptionChange(e, this, String)}
              >
                {Object.keys(this.vpmtList).map(item => (
                  <option key={item} value={item}>
                    {this.vpmtList[item]}
                  </option>
                ))}
              </select>
              <div className="validationError"></div>
            </div>
          </div>
          <div className="inputsRow">
            <div className="bigInput">
              <label>pgDomain</label>
              <input
                type="text"
                name="pgDomain"
                key={this.props.rtb.pgDomain}
                className="textFiled"
                defaultValue={this.props.rtb.pgDomain}
              />
              <div className="validationError"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RTBSettings;
